import { Col, Form, Input, Row } from 'antd'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { values } from 'lodash'
import React from 'react'
import { adminSettingStore } from 'state/setting/admin'
import FindEmail from './ModalContent/FindEmail'

const AddAdmin: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { addAdminModal, setAddAdminModal, setAdminData } = adminSettingStore(
    store => ({
      addAdminModal: store.addAdminModal,
      setAddAdminModal: store.setAddAdminModal,
      adminData: store.adminData,
      setAdminData: store.setAdminData,
    }),
  )

  const closeModal = () => {
    setAdminData(null)
    setAddAdminModal(false)
  }

  const onFinish = (values: { email: string }) => {
    console.log(values, 'values...')
  }

  return (
    <>
      <CustomModal
        openModal={addAdminModal}
        isCloseModalCustom={true}
        closeModal={closeModal}
        title="Add Admin"
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-between"
            btnText="Find Email"
            closeModal={closeModal}
            onSubmit={handleSubmit}
          />
        }
      >
        <p>
          Please enter the admin's email. We will check our system to see if
          this account already exists.
        </p>
        <FindEmail form={form} />
      </CustomModal>
    </>
  )
}

export default AddAdmin
